import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useReveal, revealClass } from "../hooks/useReveal";

export const About = () => {
  const { t } = useLanguage();
  const [titleRef, titleVisible] = useReveal();
  const [bodyRef, bodyVisible] = useReveal();

  return (
    <section
      id="about"
      data-testid="section-about"
      className="py-24 md:py-32 border-t border-line bg-white scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-16">
          <div className="col-span-12 md:col-span-4">
            <div ref={titleRef} className={revealClass(titleVisible)}>
              <p className="section-index mb-6" data-testid="about-index">
                {t.about.index}
              </p>
              <h2
                className="font-serif-display font-light tracking-tight text-ink text-5xl md:text-6xl leading-none"
                data-testid="about-title"
              >
                {t.about.title}
              </h2>
            </div>
          </div>

          <div className="col-span-12 md:col-span-8">
            <div ref={bodyRef} className={revealClass(bodyVisible)}>
              <p
                className="dropcap font-serif-display text-2xl md:text-3xl text-ink leading-relaxed font-light"
                data-testid="about-p1"
              >
                {t.about.p1}
              </p>
              <p
                className="mt-6 text-lg text-ink-soft leading-relaxed font-light max-w-3xl"
                data-testid="about-p2"
              >
                {t.about.p2}
              </p>
              <p
                className="mt-6 text-lg text-ink-soft leading-relaxed font-light max-w-3xl"
                data-testid="about-p3"
              >
                {t.about.p3}
              </p>

              <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 border-t border-line">
                {t.about.pillars.map((p, i) => (
                  <div
                    key={i}
                    data-testid={`about-pillar-${i}`}
                    className={`py-6 ${
                      i > 0 ? "sm:border-l border-line sm:pl-8" : ""
                    }`}
                  >
                    <p className="eyebrow mb-2">{p.k}</p>
                    <p className="font-serif-display text-xl text-ink leading-snug">
                      {p.v}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
